import { useEffect, useState } from "react";
import { useApi, fmtDate } from "../lib/api";
import { StatusBadge } from "../components/StatusBadge";

const LABELS = {
  first_login: "Primeiro acesso", access_denied: "Acesso negado", "2fa_setup_started": "Configuração 2FA iniciada",
  "2fa_enabled": "2FA ativado", "2fa_login": "Login com 2FA", payout_requested: "Saque solicitado",
  payout_approved: "Saque aprovado", payout_rejected: "Saque recusado", api_key_created: "Chave de API criada",
  api_key_revoked: "Chave de API revogada", webhook_updated: "Webhook alterado", api_auth_failed: "API: chave inválida",
  api_ip_blocked: "API: IP bloqueado", deposit_link_created: "Link de pagamento criado",
};

const PROTECTIONS = [
  "Login + Google Authenticator obrigatório",
  "Código 2FA em toda ação sensível (saques, chaves, webhook)",
  "Bloqueio de 15 min após 5 códigos errados",
  "Códigos 2FA de uso único (anti-replay)",
  "Chaves de API guardadas com hash SHA-256",
  "Lista de IPs permitidos por chave",
  "Limite de requisições por IP e por chave",
  "Webhooks assinados com HMAC-SHA256",
];

export default function Security() {
  const api = useApi();
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setLogs(r.data)).catch(() => {}); }, [api]);

  return (
    <div className="space-y-8 fade-up">
      <div><p className="caption">Anti-hacker</p><h1 className="font-heading text-4xl font-extrabold sm:text-5xl">Segurança</h1></div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="protections-list">
        {PROTECTIONS.map((p) => (
          <div key={p} className="card flex items-start gap-2 py-4 text-sm text-slate-300"><span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />{p}</div>
        ))}
      </div>
      <div className="card">
        <h2 className="mb-4 font-heading text-lg font-bold">Log de auditoria</h2>
        <div className="overflow-x-auto">
          <table className="tx-table" data-testid="audit-log-table">
            <thead><tr><th>Evento</th><th>Status</th><th>IP</th><th>Detalhe</th><th>Data</th></tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id}>
                  <td>{LABELS[l.event] || l.event}</td>
                  <td><StatusBadge status={l.status} /></td>
                  <td className="font-mono text-xs">{l.ip}</td>
                  <td className="max-w-[260px] truncate text-xs text-slate-400" title={l.user_agent}>{l.detail}</td>
                  <td className="whitespace-nowrap text-xs text-slate-400">{fmtDate(l.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
